const UpdateLevelInfo = (skillInfoLevels, updatePoints, indexSkillInfo) => {
    let updateList = [...skillInfoLevels]
    updateList[indexSkillInfo] = updateList[indexSkillInfo] + updatePoints
    return updateList
}

export default UpdateLevelInfo